import Hero        from '../sections/Hero';
import HowToPlay   from '../sections/HowToPlay';
import GameModes   from '../sections/GameModes';
import Features    from '../sections/Features';
import Medals      from '../sections/Medals';
import MoodMascot  from '../sections/MoodMascot';
import DownloadCTA from '../sections/DownloadCTA';
import Footer      from '../components/Footer';

export default function Home() {
  return (
    <>
      <Hero />
      <HowToPlay />
      <GameModes />
      <Features />
      <Medals />
      <MoodMascot />
      <DownloadCTA />
      <Footer />
    </>
  );
}
